import { render, staticRenderFns } from "./SmsTemplate.vue?vue&type=template&id=98cd9fdc&scoped=true"
import script from "./SmsTemplate.vue?vue&type=script&lang=js"
export * from "./SmsTemplate.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplate.vue?vue&type=style&index=0&id=98cd9fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cd9fdc",
  null
  
)

export default component.exports